var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center"},[_c('div',{staticClass:"imagePadding",style:(_vm.data),attrs:{"title":"grade"}})])}
var staticRenderFns = []

export { render, staticRenderFns }